import { PhoneNumberUtil } from "google-libphonenumber";

const phoneUtil = PhoneNumberUtil.getInstance();

export const isPhoneValid = (phone: string | undefined) => {
  if (!phone) {
    return false;
  }

  try {
    const parsedPhone = phoneUtil.parseAndKeepRawInput(phone);
    return phoneUtil.isValidNumber(parsedPhone);
  } catch (error) {
    return false;
  }
};
